export default __webpack_public_path__ + "static/Forced_for_Hire_and_Human_Rights_Policy-84aec4627863090aa8bac8c491f9768f.pdf";